<template>
  <div class="alloy-item">
    <div
      v-if="alloy.premiumAlloy && !store.userIsLoggedIn"
      class="alloy-item-content premium-alloy"
      :class="{ selected: isSelected, active: isActive }"
      @click="$emit('clickOnPremiumAlloy')"
    >
      <p class="w-100">PREMIUM ALLOY</p>
    </div>
    <div
      v-else
      class="alloy-item-content"
      :class="{ selected: isSelected, active: isActive }"
      :style="{ backgroundColor: backgroundColor() }"
      @click="clickOnAlloy(alloy)"
      @mouseover="addActiveAlloy(alloy)"
      @mouseleave="deactivateAlloy()"
      @touchend="touchevent"
    >
      <div class="informations" :class="{ 'dark-text': darkText }">
        <div class="main-informations">
          <p>{{ alloy.brandName }}</p>
        </div>
        <p>{{ alloy.temper }}</p>
        <div
          class="more-informations"
          :class="{ 'show-infos': showInformations }"
        >
          <p>{{ alloy.isoDesignation }}</p>
        </div>
        <div class="hidden">
          <img src="../assets/select-btn.png" alt="select" />
        </div>
      </div>
    </div>
    <div v-if="showCross()" class="cross-button" @click="clickOnAlloy(alloy)">
      &#10005;
    </div>
  </div>
</template>

<script>
import Store from "@/store";
import $ from "jquery";

export default {
  emits: ["clickOnPremiumAlloy"],
  props: {
    alloy: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean
    },
    isActive: {
      type: Boolean
    },
    showInformations: {
      type: Boolean,
      default: false,
      required: false
    },
    darkText: {
      type: Boolean,
      default: false,
      required: false
    },
    color: {
      type: String,
      default: null,
      required: false
    },
    alloyFromVisualization: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      store: Store.state
    };
  },
  methods: {
    touchevent(event) {
      this.clickOnAlloy(this.alloy);
      event.preventDefault();
    },
    clickOnAlloy(alloy) {
      this.$parent.clickOnAlloy(alloy);
    },
    addActiveAlloy(alloy) {
      if (typeof this.$parent.addActiveAlloy == "function")
        this.$parent.addActiveAlloy(alloy);
    },
    deactivateAlloy() {
      if (!this.alloyFromVisualization) this.$parent.deactivateAlloy();
    },
    backgroundColor: function() {
      if (this.color) return this.color;
      else if (this.alloy.red && this.alloy.green && this.alloy.blue) {
        return `rgb(${this.alloy.red}, ${this.alloy.green}, ${this.alloy.blue})`;
      }
    },
    showCross: function() {
      return this.isSelected && this.alloyFromVisualization;
    }
  }
};
</script>

<style lang="scss" scoped>
.alloy-item {
  position: relative;
  padding: 4px;
  height: calc((33.33vw - 20px) / 4);
  width: calc((33.33vw - 20px) / 4);
  min-height: 115px;
  min-width: 115px;
}
.alloy-item-content {
  position: relative;
  color: white;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
  padding: 4px;

  &.premium-alloy {
    display: flex;
    align-items: center;
    background: grey;
    border: 4px solid #eb6f33;
    padding: 15px;
    p {
      margin: 0;
    }
  }

  .dark-text {
    color: darkslategrey;
  }
  .informations {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 0.8em;
    .main-informations {
      font-weight: bold;
      font-size: 1.05em;
    }
    p {
      margin: 0;
    }
  }
  .more-informations,
  .hidden {
    display: none;
  }
  .show-infos {
    display: block !important;
  }
  img {
    width: 20px;
    height: 20px;
  }
  .hidden {
    border: none;
    background: transparent;
  }
  &.active,
  &:hover {
    top: 0;
    left: 0;
    transform: scale(1.05);
    cursor: pointer;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    .more-informations,
    .hidden {
      display: block;
    }
  }
  &.selected {
    border: 2px dashed darkslategrey;
  }
}

.cross-button {
  width: 20px;
  height: 20px;
  background-color: red;
  color: white;
  border-radius: 10px;
  position: absolute;
  bottom: -5px;
  right: 15px;
  z-index: 10;
  font-size: 14px;
  font-weight: bold;
  &:hover {
    cursor: pointer;
  }
}
</style>
